import ENV from "../env";

const updateInvoice = async (invoiceId, updates) => {
  const response = await fetch(`${ENV.firebaseApiUrl}/invoice/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      invoiceId,
      updates,
    }),
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error(resData.message || "Failed to update invoice");
  }

  return true;
};

export default updateInvoice;
